export const iconFontAwesomeTransportationTruckField = (
	<i className="fa-solid fa-truck-field"></i>
);
